import { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { getCaseList } from 'actionCreators/case';
import { fetchAPRData } from 'actionCreators/calculator';
import { getCustomers } from 'actionCreators/customer';
import { showHideLoader } from 'actionCreators/loader';

// we really want to return nothing until all of this is resolved
function useAppStart() {
  const {
    config: { bankId, accessToken, referrer, loanType },
    calculator: { product }
  } = useStore().getState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!product.loaded) {
      if (!referrer) {
        dispatch(fetchAPRData());
      }

      if (accessToken && bankId && !referrer && !loanType) {
        dispatch(showHideLoader(true));
        /**
         * Get the customer object for based on the customer associated with the accessToken.
         */
        dispatch(getCustomers());
        /**
         * At the same time, get a list of loan application cases that the customer associated
         * with the acccessToken.
         */
        dispatch(getCaseList(true));
      }
    }
  }, [dispatch, accessToken, bankId, loanType, product.loaded, referrer]);
}

export { useAppStart };
